// for basins and targets
import { Grid, SxProps, Typography } from '@methanesat/ui-components';
import { ReactElement } from 'react';
export const DrawerCardContentHeader = ({
    titleLabel,
    titleValue,
    locationSubtitle,
    sx
}: {
    titleLabel: string;
    titleValue?: string;
    locationSubtitle?: string | ReactElement;
    sx?: SxProps;
}) => {
    return (
        <Grid container flexDirection="row" sx={[{}, ...(Array.isArray(sx) ? sx : [sx])]}>
            <Grid>
                <Typography fontWeight={600} sx={{ marginRight: 0.5 }}>
                    {titleLabel}
                </Typography>
            </Grid>
            {titleValue && (
                <Grid>
                    <Typography>{titleValue}</Typography>
                </Grid>
            )}
            {locationSubtitle && (
                <Grid size={{ xs: 12 }}>
                    <Typography>{locationSubtitle}</Typography>
                </Grid>
            )}
        </Grid>
    );
};
